export default __webpack_public_path__ + "static/media/thumbnail1.e2d4534c.jpg";